<template>
    <div style="background-color: #fafafa;">
        <van-search shape="round" v-model="value" placeholder="请输入搜索关键词" show-action @search="onSearch"
                    @cancel="onSearch">
            <div slot="action" @click="onSearch">搜索</div>
        </van-search>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" @load="onLoad" finished-text="没有更多了">
                <div v-for="form in list" class="card" :key="form.uuid" @click="openForm(form.formDataId,form.workflowTemplate)">
                    <table class="layout">
                        <tr>
                            <td class="avatar-box" rowspan="4">
                                <img :src="avatarUrl + form.creatorIdavatar" class="avatar" alt="avatar">
                                <p class="advisor">{{form.creatorIdname}}</p>
                                <p class="advisor">{{form.departmentIdname}}</p>
                            </td>
                            <td colspan="2" >
                                <div class="header">
                                    <span class="title">{{form.serialNumber}}</span>
                                    <span class="status van-ellipsis">{{form.currentState}}</span>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="2" class="content">
                                <p>
                                    <span class="iconfont icon-file"></span>
                                    <span>{{form.formName}}</span>
                                </p>
                                <p>
                                    <span class="iconfont icon-date"></span>
                                    <span>{{form.createTime}}</span>
                                </p>
                            </td>
                        </tr>
                    </table>
                </div>
            </van-list>
        </van-pull-refresh>
    </div>
</template>

<script>
    import {Button, List, Panel, PullRefresh, Search, Tab, Tabs, Toast} from 'vant';
    import userInfo from '../store/userInfo';

    import workflowPositionService from "../service/workflowPositionService";
    import moment from "moment";
    import {formatDictionary} from "../utils/dictionary";
    import {API_URL} from "../common/config";

    export default {
        data: function () {
            return {
                selected: 0,
                list: [],
                loading: false,
                finished: false,
                pageIndex: 0,
                tab: null,
                value: "",
                refreshing: false
            }
        },
        store: userInfo,
        components: {
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [Button.name]: Button,
            [Panel.name]: Panel,
            [List.name]: List,
            [Toast.name]: Toast,
            [Search.name]: Search,
            [PullRefresh.name]: PullRefresh
        },
        computed: {
            userId() {
                return this.$store.getters.getUserId;
            },
            avatarUrl() {
                return API_URL + "/oa/common/attachment/showImage?id=";
            }
        },
        created: async function () {
        },
        methods: {
            async onLoad() {
                this.pageIndex++;
                let resp = await workflowPositionService.getWorkflowPostData(this.pageIndex, this.value);
                resp.data.Data.data.forEach(form => {
                    form.createTime = moment(form.createTime).format('YYYY-MM-DD');
                });
                formatDictionary(resp.data.Data.data, resp.data.Data.dictionary);
                this.loading = false;
                this.refreshing = false;
                this.list = [...this.list, ...resp.data.Data.data];
                this.finished = resp.data.Data.total <= this.list.length;
            },
            onSearch() {
                this.finished = false;
                this.loading = true;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
            openForm(id,workflowTemplate) {
                window.open('/wf/form/vsheet/form?workflowTemplateId='+workflowTemplate+'&id=' + id);
            },
            onRefresh() {
                this.finished = false;
                this.pageIndex = 0;
                this.list = [];
                this.onLoad();
            },
        }
    };
</script>
<style scoped>
    .van-ellipsis {
        font-size: 13px;
        margin-left: 15px;
        max-width: 100px;
    }
</style>

